export default __webpack_public_path__ + "static/media/package2.b739e8ef.png";